var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('my-swiper',{attrs:{"imgs":_vm.imgs}}),_c('selection'),_c('category'),_c('about'),_c('honor'),_c('partner'),_c('div',{staticClass:"bg-child"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }